/* eslint-disable */
import { ORDERS_ALL, ORDERS_ALL_COMPLETE, ORDERS_ALL_ERROR, ORDERS_ALL_SUCCESS } from '../Orders.types';

/**
 * Fetch all known orders
 * @returns {ActionCreator<FromPromise>} The created `Action`
 */
const ordersAll = () => ({ orderService, fromPromise, getState }) => {
  const state = getState();
  const { filters } = state;
  const promise = orderService.all(state);
  return fromPromise(promise, { params: { filters } }, [ORDERS_ALL, ORDERS_ALL_COMPLETE, ORDERS_ALL_ERROR, ORDERS_ALL_SUCCESS]);
};

export default ordersAll;
